module.exports = __webpack_public_path__ + "static/home-artist-marketing-2d8711e6338e1ccbc6b8a21f71f3a992.png";